import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders a simple HTML content viewer styled to mimic a Quill editor. This component displays HTML content
 * or a placeholder text in a read-only format.
 *
 * @param props - Contains the properties for configuring the viewer.
 * @param props.value - The HTML content to display.
 * @param props.readOnly - If true, the viewer is set to read-only mode and adjusts the background color accordingly.
 * @param props.placeholder - Text displayed when there is no content to display.
 * @param props.style - Additional CSS properties to apply to the viewer container.
 * @returns A styled div that mimics a Quill editor, displaying either the provided HTML content or a placeholder.
 */ function QuillSimpleHtmlContent({ value, readOnly, placeholder, style = {} }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "ql-container",
        style: {
            minHeight: "3rem",
            backgroundColor: readOnly ? "rgba(0, 0, 0, 0.04)" : "white",
            border: "1px solid #ccc",
            fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
            ...style
        },
        children: value ? /*#__PURE__*/ _jsx("div", {
            className: "ql-editor",
            dangerouslySetInnerHTML: {
                __html: value
            }
        }) : /*#__PURE__*/ _jsx("div", {
            className: "ql-editor",
            style: {
                color: "rgba(0, 0, 0, 0.25)"
            },
            children: placeholder || ""
        })
    });
}
export { QuillSimpleHtmlContent };
